<div *ngIf="!busy && !connected">
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.web_address' | translate}}:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="apiUrl" placeholder="https://xxxxxxxx.teamworkinsight.com/"/>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      APIKey:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="apiKey" />
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
    </div>
    <div class="col-md-8" style="text-align: end">
      <button type="button" (click)="SaveSettings()" [disabled]="apiKey.length === 0" class="iso-round-button secondary">
        {{ 'messaging.connect' | translate }}
      </button>
    </div>
  </div>
</div>


<div *ngIf="connected" class="margin-top-16">
  <div style="font-size: 13px; text-align: center;">{{'onboarding.messages.pos_connected_info' | translate}}</div>
  <app-teamwork-defaults [partner]="partner"></app-teamwork-defaults>
</div>
